import React, {Fragment, useState} from "react";
import { connect } from "react-redux";
import {injectIntl} from "react-intl";
import {withRouter} from "react-router-dom";

import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";

import MaterialSpinner from "../../../ui/materialSpinner";
import {getFeatureGroupName} from "../../../../misc/helpers";
import {getLookList} from "../lookFunctions";
import FeatureThumbnail from "../../../visComponents/featureThumbnail";
import FeatureName from "../../../visComponents/featureName";
import LookFeaturePrice from "../lookMain/lookListFeature/lookFeaturePrice";
import WithZoomToFeature from "../../hocs/withZoomToFeature";
import LookCanvasContext from "../../lookCanvasContext";
import {getCategoryOnlyUrl, getFeatureUrl, getLookIdUrl, getWizardWithFirstStepCurrentPartId} from "../lookFunctions2";
import {setLookActiveCategory} from "../../../../actions/lookFunctions";
import Analytics, {LOOK_JOURNEY_ANALYTIC_EVENTS} from "../../../../analytics";
import LookMainWizardList from "./lookMainWizardList";
import LookMainFeatureGroupsExpandIcon from "./lookMainFeatureGroupsExpandIcon";
import {getFeatureGroupIconStyles} from "../../../bvComponent/core/assets";
import Config from "../../../../config";
import WithUpdateLookCartItem from "../../hocs/withUpdateLookCartItem";
import {ROUTES} from "../../../../routes";
import {setWizardActiveItem} from "../../../../actions/wizardFunctions";

const LookMainFeatureGroups = (props) => {

  const {intl, lookActiveCategory, visualizersLoaded, fabricatorData, history, activeTheme, setLookActiveCategory,
    setWizardActiveItem, wizardList} = props;

  const [showAllGroups, setShowAllGroups] = useState(false);

  if (!visualizersLoaded.length) {
    return <MaterialSpinner/>
  }

  const showAllGroupsCheckbox = Config.isVisualizerManagement() || Config.isDevMode();

  let parentObjects = getLookList(false, true, showAllGroups, false, true);
  if (!parentObjects && !showAllGroupsCheckbox) {
    return null
  }

  const parentClick = (lmFeature, zoomToFeatureGroup, updateLookCartItem) => {
    Analytics.sendClickEvent(LOOK_JOURNEY_ANALYTIC_EVENTS.lookMainCategory + lmFeature.partId);

    const shouldOpenWizardItem = getWizardWithFirstStepCurrentPartId(wizardList, lmFeature.partId);
    if (shouldOpenWizardItem) {
      setWizardActiveItem(shouldOpenWizardItem);
      history.push(`${getLookIdUrl(false) + ROUTES.wizard}/${shouldOpenWizardItem.id}`);
      return true
    }

    zoomToFeatureGroup(lmFeature.partId, lmFeature.cartFeature, null, false);
    updateLookCartItem(lmFeature.cartFeature);

    setLookActiveCategory(lmFeature.partId);
    const url = lmFeature.cartFeature
        ? getFeatureUrl(lmFeature.cartFeature, true)
        : getCategoryOnlyUrl(lmFeature.partId);
    history.push(url);
  }

  const checkboxClick = (event) => {
    setShowAllGroups(event.target.checked);
  }

  return (
    <LookCanvasContext.Consumer>
      {(imageCanvas) => (
        <WithZoomToFeature imageCanvas={imageCanvas}>
          {(zoomToFeatureGroup) => (
            <WithUpdateLookCartItem>
              {(updateLookCartItem) => (
                <ul className="lm-parents">
                  <Fragment>
                    {showAllGroupsCheckbox ? (
                      <p className={"text-center"}>
                        <FormControlLabel
                          label={"Show All Feature Groups"}
                          className="g-filters__item"
                          control={<Checkbox checked={showAllGroups} onChange={checkboxClick} />}
                        />
                      </p>
                    ) : null}
                    {parentObjects ? parentObjects.map(lmFeature => {
                      const featureGroupName = getFeatureGroupName(lmFeature.featureGroup, intl, fabricatorData);
                      // console.log("lmFeature", lmFeature);
                      const quantity = lmFeature.featureGroup.layerPositions
                        ? Object.keys(lmFeature.featureGroup.layerPositions).reduce((total, position) => {
                          return total + (lmFeature.featureGroup.layerPositions[position] ? 1 : 0)
                        }, 0)
                        : 1;
                      return (
                        <li className="lm-parent"
                            data-key={lmFeature.partId}
                            key={lmFeature.partId}
                            onClick={() => parentClick(lmFeature, zoomToFeatureGroup, updateLookCartItem)}>
                          <div className="lm-feature__thumbnail">
                            {lmFeature.cartFeature
                              ? <FeatureThumbnail feature={lmFeature.cartFeature}
                                                  lookActiveCategory={lookActiveCategory}
                                                  dbFeatureId={lmFeature.cartFeature.dbFeature.id}/>
                              : <div className="feature-thumbnail feature-thumbnail--bg"
                                     style={getFeatureGroupIconStyles(lmFeature.featureGroup, activeTheme)}/>}
                          </div>
                          <div className="lm-parent__content">
                            <span className="lm-feature__content-name">
                              {featureGroupName}
                            </span>
                            <p className="lm-parent__content-name">
                              {lmFeature.cartFeature ? <FeatureName feature={lmFeature.cartFeature} useCollectionName={true}/> : null}
                            </p>
                            <div className="lm-feature__content-price">
                              {lmFeature.cartFeature ? <LookFeaturePrice lookFeature={lmFeature.cartFeature} quantity={quantity}/> : null}
                            </div>
                          </div>
                          <LookMainFeatureGroupsExpandIcon/>
                        </li>
                      )
                    }) : null}
                    <LookMainWizardList/>
                  </Fragment>
                </ul>
              )}
            </WithUpdateLookCartItem>
          )}
        </WithZoomToFeature>
      )}
    </LookCanvasContext.Consumer>
  )
};

const mapStateToProps = (store) => {
  const {lookActiveFeature, lookActiveCategory} = store.lookState;
  const {visualizersLoaded, activeTheme} = store.serverState;
  const {wizardList} = store.wizardState;

  return {
    lookActiveCategory,
    lookActiveFeature, // not used, only for updates
    visualizersLoaded,
    fabricatorData: store.fabricatorState,
    activeTheme,
    wizardList,
  };
};

const mapDispatchToProps = {
  setLookActiveCategory,
  setWizardActiveItem,
};

export default withRouter(
  injectIntl(
    connect(mapStateToProps, mapDispatchToProps)(LookMainFeatureGroups)
  )
)
